var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApproveLabel = function SvgApproveLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#23305F",
    d: "m.5 14.5 5.5-7L.5.481h11.673q.378 0 .717.155t.556.453L18.5 7.5l-5.034 6.393q-.218.298-.556.452a1.7 1.7 0 0 1-.718.155zm2-1h9.712q.153 0 .269-.057a.7.7 0 0 0 .211-.173L17.25 7.5l-4.558-5.788a.7.7 0 0 0-.211-.173.6.6 0 0 0-.27-.058H2.5l4.75 6.02z"
  })));
};
export default SvgApproveLabel;